import React, { useEffect, useState } from "react";
import { Input } from "@/components/shadcn/ui/input";
import { Textarea } from "@/components/shadcn/ui/textarea";
import { Button } from "@/components/shadcn/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/shadcn/ui/card";

interface Template {
  id: string;
  title: string;
  content: string;
}

const EmailTemplatesPage: React.FC = () => {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  
  const API_URL = "/ws/api";
  

  useEffect(() => {
    fetch(`${API_URL}/templates`)
      .then((res) => res.json())
      .then(setTemplates)
      .catch((err) => console.error("Erro ao carregar templates:", err));
  }, []);

  const handleSaveTemplate = async () => {
    const response = await fetch(`${API_URL}/templates`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title, content }),
    });

    if (response.ok) {
      alert("Template salvo!");
      setTitle("");
      setContent("");
      setTemplates([...templates, { id: Date.now().toString(), title, content }]);
    } else {
      alert("Erro ao salvar template.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-indigo-200 p-1">
      <Card className="w-full max-w-lg shadow-lg rounded-lg bg-white">
        <CardHeader>
          <CardTitle className="text-center text-2xl font-bold">Templates de E-mail</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Título do Template" />
            <Textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="Conteúdo do E-mail" />
            <Button className="w-full" onClick={handleSaveTemplate}>Salvar Template</Button>
          </div>
        </CardContent>
      </Card>

      <div className="mt-8 w-full max-w-lg">
        <h2 className="text-xl font-semibold mb-4">Templates Salvos</h2>
        {templates.map((template) => (
          <Card key={template.id} className="mb-4 p-4 bg-white shadow-md">
            <h3 className="font-bold">{template.title}</h3>
            <p className="text-gray-700">{template.content}</p>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default EmailTemplatesPage;
